import React from "react";
import { HomeScreenWithMyPets } from "~/features/home/HomeScreen";

const Component = () => {
  return <HomeScreenWithMyPets />;
};

export default Component;
